window.subscribeHelpers = {

    /* ---------------------- PUBLIC API ----------------------- */

    async updateProductSubscribe(vm, product) {

        if (!window.globalState.isAuth) {
            window.globalState.addNotification(
                "Для подписки на товар необходимо авторизоваться."
            );
            return;
        }

        const original = product.isSubscribed;

        // оптимистичное обновление
        product.isSubscribed = !original;

        this.debounceSubscribe(vm, product, original);
    },

    /* ---------------------- DEBOUNCE -------------------------- */

    debounceSubscribe(vm, product, originalState) {

        if (!vm.subscribeTimeouts) vm.subscribeTimeouts = new Map();

        clearTimeout(vm.subscribeTimeouts.get(product.id));

        const id = setTimeout(() => {
            this.sendSubscribeUpdate(product, originalState, vm);
            vm.subscribeTimeouts.delete(product.id);
        }, 300);

        vm.subscribeTimeouts.set(product.id, id);
    },

    /* ---------------------- SERVER REQUEST --------------------- */

    async sendSubscribeUpdate(product, originalState, vm) {
        try {
            const data = await this.api(
                window.laravelConfig.routes.updateSubscribe,
                {
                    product_id: product.id,
                    is_subscribed: product.isSubscribed
                }
            );

            if (!data.success) {
                product.isSubscribed = originalState;
                return;
            }

            if (vm.subscriptions && !product.isSubscribed) {
                vm.subscriptions = vm.subscriptions.filter(
                    p => p.id !== product.id
                );
            }

        } catch (e) {
            product.isSubscribed = originalState;
        }
    },

    /* ---------------------- SHARED API -------------------------- */

    async api(url, payload) {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-TOKEN": window.laravelConfig.csrfToken,
                "Accept": "application/json"
            },
            body: JSON.stringify(payload)
        });

        return response.json();
    }
};